"use strict";

define('rs/form/formobjects/sponsor.finder/sponsor.finder.formobject.view',['rs/form/formobjects/base.formobject.view'], function (BaseFormObjectView) {
  var AttachFormObjectView = BaseFormObjectView.extend({
    templates: {
      'sponsor.finder.formobject': 'renderFormControls'
    },
    events: {
      'click >.form-object-contents .btn-sponsor-finder:not(.disabled)': 'handleClick',
      'keydown >.form-object-contents .btn-sponsor-finder:not(.disabled)': 'handleKeydown',
      'mouseover >.form-object-contents .btn-sponsor-finder:not(.disabled)': 'handleFindBtnMouseOver',
      'mouseleave >.form-object-contents .btn-sponsor-finder:not(.disabled)': 'handleFindBtnMouseLeave'
    },
    renderFormObjectControls: function renderFormObjectControls(templateProperties) {
      return this.renderFormControls(templateProperties);
    },
    refresh: function refresh() {
      this._super.apply(this, arguments);
      if (this.rendered) {
        this.refreshFormObjectWithValue();
      }
    },
    refreshFormValueForPDF: function refreshFormValueForPDF() {
      var container = this.getDisplayContainer(),
        sponsors = this.getDelegate().getSponsors();
      container.empty();
      if (sponsors.length) {
        container.append(_.pluck(sponsors, 'name').join(', '));
      }
    },
    refreshFormObjectWithValue: function refreshFormObjectWithValue() {
      var container = this.getDisplayContainer(),
        delegate = this.getDelegate(),
        sponsors = delegate.getSponsors() || [];
      delegate.view.$el.find(".btn-sponsor-finder").attr("aria-label", delegate.getText().split(/<[^>]*>/).join('') + " Find Sponsors");
      if (sponsors.length) {
        container.show();
      } else {
        container.hide();
      }
      delegate.getDisplayTable().setFlag('forceRenderAll', true);
      delegate.getDisplayTable().getView().setElement(container);
      delegate.getDisplayTable().refresh();
      if (!delegate.getHasMultiple() && sponsors.length > 0 || delegate.isReadOnly() && !delegate.isDesignerMode()) {
        this.hideButton();
      } else {
        container.addClass('visible-finder');
        this.showButton();
      }
    },
    getDisplayContainer: function getDisplayContainer() {
      return this.$('.sponsor-finder-display').css('min-width', 500);
    },
    hideButton: function hideButton() {
      this.$el.find('.btn-sponsor-finder').hide();
    },
    showButton: function showButton() {
      this.$el.find('.btn-sponsor-finder').show();
    },
    getValue: function getValue() {
      return this.formObjectValue && this.formObjectValue.length ? JSON.stringify(this.formObjectValue) : null;
    },
    handleKeydown: function handleKeydown(ev) {
      if (ev.keyCode === 13) {
        this.handleClick(ev);
      }
    },
    handleClick: function handleClick(ev) {
      this.getDelegate().requestSponsorModal();
    },
    handleFindBtnMouseOver: function handleFindBtnMouseOver() {
      var delegate = this.getDelegate();
      delegate.view.$el.find('.btn-sponsor-finder').html(delegate.getText().split(/<[^>]*>/).join('') + ' Find Sponsors');
    },
    handleFindBtnMouseLeave: function handleFindBtnMouseLeave() {
      var delegate = this.getDelegate();
      delegate.view.$el.find('.btn-sponsor-finder').html(' Find Sponsors');
    }
  });
  return AttachFormObjectView;
});

